/**
 * Labels for a list's saved Apollo config entries, read by type in `LeadFilterList`
 * (`prospectSearch.${row.type}`). The admin prospect search's strings went with its pages
 * (PREC-5023).
 */
export const enProspectSearch = {
	SOURCE: "Source / Filter",
	LEAD_FILTER: "Department filter",
	LEAD_EXCLUSION: "Department exclusion",
	COUNTER: "Department size",
};
